
import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

const textColors = ["#0057B7", "#C71122", "#FFD700", "#1F0A97"];

const ColoredLogo = ({ hasDarkBg }: { hasDarkBg: boolean }) => {
  const [isHovered, setIsHovered] = useState(false);
  const text = "bekah june";
  
  return (
    <NavLink 
      to="/" 
      className="font-sans text-lg md:text-2xl font-normal tracking-tight"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {text.split("").map((char, index) => (
        <span
          key={index}
          className="transition-colors duration-300"
          style={{
            color: isHovered && char !== " " 
              ? textColors[index % textColors.length] 
              : hasDarkBg ? "#FFFEF7" : "#000000"
          }}
        >
          {char}
        </span>
      ))}
    </NavLink>
  );
};

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isResumePage = location.pathname === "/resume";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? "py-2 md:py-3 bg-[#FFFFFF]" 
          : isResumePage 
            ? "py-4 md:py-6 bg-transparent" 
            : "py-4 md:py-6 bg-[#FFFFFF]"
      }`}
    >
      <div className="layout flex items-center justify-between">
        <ColoredLogo hasDarkBg={isResumePage && !isScrolled} />

        {/* Navigation - visible on all screen sizes */}
        <nav className="flex items-center space-x-4 md:space-x-8">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `nav-link nav-link-about text-xs md:text-sm ${isActive ? "nav-link-active" : ""} ${isResumePage && !isScrolled ? "text-white" : ""}`
            }
          >
            about
          </NavLink>
          <NavLink
            to="/essays"
            className={({ isActive }) =>
              `nav-link nav-link-essays text-xs md:text-sm ${isActive ? "nav-link-active" : ""} ${isResumePage && !isScrolled ? "text-white" : ""}`
            }
          >
            essays
          </NavLink>
          <NavLink
            to="/work"
            className={({ isActive }) =>
              `nav-link nav-link-projects text-xs md:text-sm ${isActive ? "nav-link-active" : ""} ${isResumePage && !isScrolled ? "text-white" : ""}`
            }
          >
            work
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              `nav-link nav-link-resume text-xs md:text-sm ${isActive ? "nav-link-active" : ""} ${isResumePage && !isScrolled ? "text-white" : ""}`
            }
          >
            hello
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
